"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/events/isEvent.js
 ** module id = 933
 ** module chunks = 0
 **/